import { Directive, Input, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[editorInputTemplate]'
})
export class EditorInputDirective {
  @Input() currentComponent: any;

  constructor(public viewContainerRef: ViewContainerRef) { }

  /*   ngOnChanges(changes: SimpleChanges): void {
      if(changes["inputComponent"]){
        console.log(this.inputComponent)
        if(this.inputComponent != undefined){
          this.currentComponent = this.inputComponent.component;
        }
      }
    } */
}
